import { render, staticRenderFns } from "./SLeftSideComponent.vue?vue&type=template&id=70f6eb3e"
import script from "./SLeftSideComponent.vue?vue&type=script&lang=js"
export * from "./SLeftSideComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports